import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { EnvService } from './env.service'
@Injectable({
  providedIn: 'root'
})
export class PublisherService {
  publisherId: string;

  
  constructor(private http: HttpClient, private EnvService: EnvService) { }



fetchPublisherId() {
    return this.http.get(
        this.EnvService.siteApiUrl + 'web/getPublisherId'
    );
}
}
